import { Answer } from "../Model/Answer";
import { v4 as uuidv4 } from 'uuid';
export class AnswersFactory {
    createAnswer(question, instanceId) {
        return new Answer(uuidv4(), instanceId, question.id, '');
    }
}
